<template>
  <div class="d-none" />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ApiMeuPerfil from '@/api/meuPerfil';

const crypto = require('crypto');

export default {
  name: 'ChatBot',

  data() {
    return {
      key: process.env.VUE_APP_TOKEN_CHATBOT,
      secretKey: process.env.VUE_APP_SECRET_CHATBOT,
    };
  },

  computed: {
    ...mapGetters(['primeiroNomeUsuario']),
    ...mapState(['userEmail']),

    disabledChatbox() {
      const router = !!this.$router.currentRoute;
      if (router) {
        return !!this.$router.currentRoute.meta.disabledChatbox;
      }
      return false;
    },
  },

  mounted() {
    if (!this.disabledChatbox) {
      if (this.userEmail) {
        this.chatDados();
        this.chatInit();
      } else {
        this.getDadosUser();
      }
    } else {
      this.removeChat();
      this.removeTagScript();
    }
  },

  methods: {
    ...mapActions(['setUserEmail']),

    getDadosUser() {
      ApiMeuPerfil.userData()
        .then((response) => {
          this.setUserEmail(response.data.email);
          this.chatDados();
          this.chatInit();
        })
        .catch(() => {
          this.setUserEmail('');
        });
    },

    removeChat() {
      const el = document.getElementById('intercom-frame');
      const frame = document.querySelector('.intercom-lightweight-app');

      if (el) {
        delete window.Intercom;
        el.remove();
      }
      if (frame) { frame.remove(); }
    },

    removeTagScript() {
      const src = `https://widget.intercom.io/widget/${this.key}`;
      const tag = document.querySelector(`script[src="${src}"]`);
      if (tag) { tag.remove(); }
    },

    chatDados() {
      const email = this.userEmail;
      const id = this.key;
      const name = this.primeiroNomeUsuario;
      const src = `https://widget.intercom.io/widget/${this.key}`;
      const token = crypto.createHmac('sha256', this.secretKey).update(email).digest().toString('hex');

      this.removeTagScript();

      const script = document.createElement('script');
      script.setAttribute('src', src);
      script.onload = function load() {
        window.intercomSettings = {
          api_base: 'https://api-iam.intercom.io',
          app_id: id,
          name,
          email,
          user_hash: token,
          created_at: Date.now(),
        };
      };

      document.body.appendChild(script);
    },

    chatInit() {
      const scriptIntercom = document.createElement('script');
      const url = `https://widget.intercom.io/widget/${this.key}`;

      scriptIntercom.onload = this.chatScript(url);
    },

    chatScript(url) {
      /* eslint-disable */
      var w=window;
      var ic=w.Intercom;
      if (typeof ic==="function") {
        ic('reattach_activator');ic('update',w.intercomSettings);
      } else {
        var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src=`${url}`;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}
      }
      /* eslint-enable */
    },
  },
};
</script>
